import React from "react"

export default function TypeTextareaRich({ value }) {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: value,
      }}
    />
  )
}
